import React, { memo } from 'react';
import PropTypes from 'prop-types';
import renderIf from '@signal/utils/renderIf';
import { Link, Icon } from './styles';
export function ExternalLink(_ref) {
  var to = _ref.to,
      children = _ref.children,
      openInNewTab = _ref.openInNewTab;
  return /*#__PURE__*/React.createElement(Link, {
    href: to,
    target: openInNewTab && '_blank'
  }, children, renderIf(openInNewTab, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "inherit"
  })));
}
ExternalLink.defaultProps = {
  openInNewTab: true
};
ExternalLink.propTypes = {
  to: PropTypes.string.isRequired,
  openInNewTab: PropTypes.bool
};
export default /*#__PURE__*/memo(ExternalLink);